/* eslint-disable vue/attribute-hyphenation */
<template>
  <div>
    <form-wizard
      ref="formWizard"
      color="#7367F0"
      :title="null"
      :subtitle="null"
      finish-button-text="Submit"
      back-button-text="Previous"
      class="steps-transparent mb-3"
      @on-complete="formSubmitted"
    >
      <tab-content
        title="Choose Panel"
        icon="feather icon-bar-chart"
      >
        <b-row>
          <b-col>
            <b-tabs
              class="mb-3"
              pills
            >
              <b-row
                class="mb-2 border-bottom pb-2"
              />
              <b-tab
                title="Statistics"
                active
              >
                <b-row class="match-height">

                  <b-col
                    cols="3"
                    @click="choosePanel('StatisticCardVertical')"
                  >
                    <statistic-card-vertical
                      icon="EyeIcon"
                      statistic="36.9k"
                      statistic-title="Views"
                      color="info"
                    />
                  </b-col>
                  <b-col
                    cols="3"
                    @click="choosePanel('StatisticCardWithAreaChart')"
                  >
                    <statistic-card-with-area-chart
                      v-if="subscribersGained.analyticsData"
                      icon="UsersIcon"
                      :statistic="kFormatter(subscribersGained.analyticsData.subscribers)"
                      statistic-title="Subscribers Gained"
                      :chart-data="subscribersGained.series"
                    />
                  </b-col>
                </b-row>
                <b-row
                  class="match-height"
                />
              </b-tab>
              <b-tab title="Analytics">
                <b-row class="match-height">
                  <b-col
                    cols="6"
                    @click="choosePanel('Chart')"
                  >
                    <chart />
                  </b-col>
                  <!-- Bar Chart
                  <b-col
                    cols="6"
                    @click="choosePanel('BarChart')"
                  >
                    <bar-chart />
                  </b-col>
                  -->
                </b-row>
              </b-tab>

              <!--- Maps --->
              <b-tab title="Maps">
                <b-row class="match-height">
                  <b-col
                    @click="choosePanel('LeafletBasic')"
                  >
                    <leaflet-basic />
                  </b-col>
                </b-row>
              </b-tab>

              <!-- Data Display -->
              <b-tab title="Data Display">
                <b-row class="match-height">
                  <b-col
                    title="Data Display"
                    cols="6"
                    @click="choosePanel('Table')"
                  >
                    <b-img
                      src="@/assets/images/mockups/table.jpg"
                      fluid
                    />
                  </b-col>
                </b-row>
              </b-tab>

            </b-tabs>
          </b-col>
        </b-row>
      </tab-content>

      <tab-content
        title="Configure Panel"
        icon="feather icon-settings"
        lazy
      >
        <b-row>
          <b-col
            cols="12"
            class="mb-2"
          >
            <h5 class="mb-0">
              Configure Panel
            </h5>
            <small class="text-muted">Configure The Panel</small>
          </b-col>
        </b-row>
        <component
          :is="panelconfig.panel + 'Config'"
          v-if="panelconfig.panel !== undefined"
          v-bind="{panelconfig: panelconfig, }"
        />
      </tab-content>
    </form-wizard>
  </div>
</template>

<script>
import { FormWizard, TabContent } from 'vue-form-wizard'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import {
  BRow,
  BCol,
  BTab,
  BTabs,
  BCardText,
  BImg,
} from 'bootstrap-vue'
import { kFormatter } from '@core/utils/filter'
// Statistics
import StatisticCardHorizontal from '../Panels/Statistics/StatisticCardHorizontal.vue'
import StatisticCardHorizontalConfig from '../Panels/Statistics/StatisticCardHorizontalConfig.vue'

import StatisticCardVertical from '../Panels/Statistics/StatisticCardVertical/StatisticCardVertical.vue'
import StatisticCardVerticalConfig from '../Panels/Statistics/StatisticCardVertical/StatisticCardVerticalConfig.vue'

import StatisticCardWithAreaChart from '../Panels/Statistics/StatisticCardWithAreaChart/StatisticCardWithAreaChart.vue'
import StatisticCardWithAreaChartConfig from '../Panels/Statistics/StatisticCardWithAreaChart/StatisticCardWithAreaChartConfig.vue'

// Analytics
import Chart from '../Panels/Analytics/LineChart/LineChart.vue'
import ChartConfig from '../Panels/Analytics/LineChart/LineChartConfig.vue'
import BarChart from '../Panels/Analytics/BarChart/BarChart.vue'
import BarChartConfig from '../Panels/Analytics/BarChart/BarChartConfig.vue'

// Maps
import LeafletBasic from '@/@core/components/maps/leaflet/LeafletBasic.vue'
import LeafletBasicConfig from '@/@core/components/maps/leaflet/LeafletBasicConfig.vue'

// Data Display
import Table from '../Panels/DataDisplay/Table.vue'
import TableConfig from '../Panels/DataDisplay/TableConfig.vue'

export default {
  components: {
    FormWizard,
    TabContent,
    BRow,
    BCol,
    BTab,
    BTabs,
    BCardText,
    BImg,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,

    // Statistics
    StatisticCardHorizontal,
    StatisticCardHorizontalConfig,

    StatisticCardVertical,
    StatisticCardVerticalConfig,

    StatisticCardWithAreaChart,
    StatisticCardWithAreaChartConfig,

    // Analytics
    Chart,
    ChartConfig,
    BarChart,
    BarChartConfig,

    // Maps
    LeafletBasic,
    LeafletBasicConfig,

    // Data Display
    Table,
    TableConfig,
  },
  data() {
    return {
      panel: '',
      panelconfig: {
        panel: '',
        dataSources: [],
      },
      // Area charts
      subscribersGained: {},
      revenueGenerated: {},
      quarterlySales: {},
      ordersRecevied: {},

      // Line Charts
      siteTraffic: {},
      activeUsers: {},
      newsletter: {},

    }
  },
  created() {
    // Subscribers gained
    this.$http.get('/card/card-statistics/subscribers')
      .then(response => { this.subscribersGained = response.data })

    // Revenue Generated
    this.$http.get('/card/card-statistics/revenue')
      .then(response => { this.revenueGenerated = response.data })
  },
  methods: {
    kFormatter,
    choosePanel(panel) {
      this.panel = panel
      this.panelconfig.panel = panel
      this.panelconfig.noHover = true
      this.$refs.formWizard.nextTab()
    },
    formSubmitted() {
      this.$emit('addPanel', this.panelconfig)
      this.$toast({
        component: ToastificationContent,
        props: {
          title: 'Panel Created',
          icon: 'SquareIcon',
          variant: 'success',
        },
      })
    },

  },
}
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-wizard.scss";
@import "@core/scss/vue/libs/vue-select.scss";
</style>
